import {
  CurrencySchema,
  PriceBookCountriesSchema,
  PriceBookRowSchema,
  PriceBookStatusSchema,
} from "@redotech/redo-inventory-common/price-book/price-book";
import { priceBookIdFormat } from "@redotech/redo-marketplace-id";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const updatePriceBook = unaryRpc({
  name: "updatePriceBook" as const,
  input: z.object({
    priceBookId: priceBookIdFormat.schema,
    name: z.string().min(1),
    description: z.string(),
    status: PriceBookStatusSchema,
    currency: CurrencySchema.nullable().optional(),
    countryCodes: PriceBookCountriesSchema.optional(),
  }),
  output: z.object({ priceBook: PriceBookRowSchema }),
});
